import React from 'react';
import PropTypes from 'prop-types';
import Footer from './footer/footer';
import GlobalNav from './global-nav/global-nav';
import constants from '../utils/constants';
const { privacyPolicyNotice } = constants;
import { readCookie, createCookie } from '../utils/cookie';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrivacyPolicyBannerOpen: false,
      modalOpenTrigger: null
    };
  }

  componentDidMount() {
    this.detectDeviceAndApplyClasses();
    // Have to wait until componentDidMount to set state because shouldRenderPrivacyUpdateNotice
    // relies on window.document.cookies. Window.document isn't guaranteed to exist until this
    // point in the React lifecycle. Trying to access earlier was causing bugs.
    if (this.shouldRenderPrivacyUpdateNotice()) {
      this.setState({ isPrivacyPolicyBannerOpen: true }); //eslint-disable-line
      // listen for the escape key to close the privacy notice
      document.addEventListener('keydown', this.escFunction, false);
    }
  }

  // shouldn't happen since this component should stay on the page, but just in case
  componentWillUnmount() {
    this.stopListeningForEscape();
  }

  stopListeningForEscape = () => {
    document.removeEventListener('keydown', this.escFunction, false);
  };

  detectDeviceAndApplyClasses = () => {
    const ua = navigator.userAgent.toLowerCase();
    const android = /android/.test(ua) && !window.MSStream;
    const ios = /ipad|iphone|ipod/.test(ua) && !window.MSStream;
    const iphone = /iphone|ipod/.test(ua) && !window.MSStream;
    const ipad = /ipad/.test(ua) && !window.MSStream;

    let className = '';
    className += !android && !ios ? 'body-platform-desktop ' : '';
    className += android || ios ? 'body-platform-mobile ' : '';
    className += android ? 'body-platform-android ' : '';
    className += ios ? 'body-platform-ios ' : '';
    className += iphone ? 'body-platform-iphone ' : '';
    className += ipad ? 'body-platform-ipad ' : '';

    document.body.classList.add(...className.trim().split(' '));
  };

  escFunction = (event) => {
    const isEscPressed = event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
    if (!isEscPressed) {
      return;
    }
    this.handlePrivacyUpdateNoticeDismiss();
    this.stopListeningForEscape();
  };

  handlePrivacyUpdateNoticeDismiss = () => {
    const { updated, cookie, dayThreshold } = privacyPolicyNotice;
    this.setState({ isPrivacyPolicyBannerOpen: false });
    createCookie(cookie, updated, dayThreshold);
  };

  shouldRenderPrivacyUpdateNotice = () => {
    const { updated, cookie } = privacyPolicyNotice;

    const dayThreshold = 3 * 30; // usually three months
    const dayThresholdAgo = Date.now() - dayThreshold * 24 * 60 * 60 * 1000;

    const lastUpdatedParsed = Date.parse(updated);

    const noticeDismissed = readCookie(cookie);
    const noticeDismissedParsed = Date.parse(noticeDismissed);

    // on the off chance that lastUpdated is NaN, do nothing
    if (!lastUpdatedParsed) {return false;}

    // if it was updated more than 3 months ago, do nothing
    if (lastUpdatedParsed < dayThresholdAgo) {return false;}

    // if there's no cookie, or the update is more recent, show the notice
    if (!noticeDismissedParsed || noticeDismissedParsed < lastUpdatedParsed) {
      return true;
    }

    return false;
  };
  render() {
    return (
      <div className="index-layout fonts-loaded">
        {/* Updated privacy policy notice */}
        <div className="privacy-update" style={{ display: this.state.isPrivacyPolicyBannerOpen ? 'block' : 'none' }}>
          <div className="privacy-update-content">
            We encourage you to read our updated <a href="https://www.speedtest.net/about/privacy">Privacy Policy</a>{' '}
            and <a href="https://www.ziffdavis.com/cookie-policy">Cookie Policy</a>.
          </div>
          <a
            href="#"
            className="close-btn"
            onClick={(e) => {
              e.preventDefault();
              this.handlePrivacyUpdateNoticeDismiss();
            }}
            aria-label="Close"
            role="button"
          >
            <svg className="svg-icon">
              <use xlinkHref="#ic_close" />
            </svg>
          </a>
        </div>
        <GlobalNav />
        <div className="children-container">{this.props.children}</div>
        <Footer />
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.object.isRequired
};

export default Layout;
